import SupprimeStamp from "./SupprimeStamp";
import AjouteStamp from "./AjouteStamp";
import ModifieStamp from "./ModifieStamp";
import DefaultStamp from "./DefaultStamp";
import AjouteTeleserviceStamp from "./AjouteTeleserviceStamp";

export default {
    install(Vue) {
        Vue.component("a-default-stamp", DefaultStamp);
        Vue.component("a-supprime-stamp", SupprimeStamp);
        Vue.component("a-ajoute-stamp", AjouteStamp);
        Vue.component("a-modifie-stamp", ModifieStamp);
        Vue.component("a-ajoute-teleservice-stamp", AjouteTeleserviceStamp);
    }
}
